import styled from '@emotion/styled';
import {
  SectionWrapper,
  Sidebar,
} from '@zola/zola-ui/src/components/PreAuthV3/Differentiation.styles';

export const WeddingRegistryContainer = styled.div`
  ${SectionWrapper} {
    height: auto;
  }

  ${Sidebar} {
    height: fit-content;
  }
`;
